/**
 * Development and executive claims cannot view client PHI, even when stacked with staff or manager.
 * Admins keep client access.
 * @param {object|null|undefined} user AuthContext user
 * @returns {boolean}
 */
export function canViewClientPhi(user) {
  if (!user) {
    return false;
  }
  const claims = user.claims || user.customClaims || {};
  const isDevelopment = user.isDevelopment === true || claims.development === true;
  const isExecutive = user.isExecutive === true || claims.executive === true;
  if (!isDevelopment && !isExecutive) {
    return true;
  }
  return user.isAdmin === true || claims.admin === true;
}
